const empty=v=>v==null||v==='';
const cents=v=>Math.round(Number(v)*100);
export const autoFinance=f=>Object.fromEntries(['agreed_fee','invoice_amount_1','invoice_amount_2'].map(k=>[k,empty(f[k])]));
export function changeFinance(f,key,value,automatic,legacyPaid=0){
 const next={...f,[key]:value},auto={...automatic};
 if(key in auto)auto[key]=false;
 const locked=i=>!!(f['invoice_no_'+i]||f['invoice_date_'+i]||Number(f['paid_amount_'+i])>0||Number(legacyPaid)>0);
 if(key==='tender_fee'&&auto.agreed_fee)next.agreed_fee=value;
 const agreed=cents(next.agreed_fee);
 if((key==='agreed_fee'||(key==='tender_fee'&&auto.agreed_fee))&&!empty(next.agreed_fee)&&Number.isFinite(agreed)&&agreed>=0){
  const a1=auto.invoice_amount_1&&!locked(1),a2=auto.invoice_amount_2&&!locked(2);
  if(a1&&a2){next.invoice_amount_1=(Math.floor(agreed/2)/100).toFixed(2);next.invoice_amount_2=((agreed-Math.floor(agreed/2))/100).toFixed(2);}
  else if(a2&&!empty(next.invoice_amount_1)&&cents(next.invoice_amount_1)<=agreed)next.invoice_amount_2=((agreed-cents(next.invoice_amount_1))/100).toFixed(2);
  else if(a1&&!empty(next.invoice_amount_2)&&cents(next.invoice_amount_2)<=agreed)next.invoice_amount_1=((agreed-cents(next.invoice_amount_2))/100).toFixed(2);
 }
 if(key==='invoice_amount_1'&&auto.invoice_amount_2&&!locked(2)&&!empty(value)&&!empty(next.agreed_fee)&&cents(value)<=agreed)next.invoice_amount_2=((agreed-cents(value))/100).toFixed(2);
 if(key==='invoice_date_1'&&value&&!next.invoice_due_date_1)next.invoice_due_date_1=value;
 if(key==='invoice_date_2'&&value&&!next.invoice_due_date_2)next.invoice_due_date_2=value;
 return {fin:next,auto};
}
